import React from "react";
import { Form, Select, Button, Typography, Flex } from "antd";

const { Option } = Select;
const { Text } = Typography;

export default function VisaOptionsCard() {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    // handle submission logic here
  };
  const { Text, Paragraph, Title } = Typography;
  return (
    <div className="container">
      {/* Title */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-medium text-danger">
          <span className="text-primary"> Dubai Visa </span> Prices & Options
        </h2>
      </div>

      {/* Card Content */}
      <div className=" bg-[rgba(224,234,255,0.33)]  rounded-xl p-6 flex flex-col justify-between items-start">
        <Paragraph className="font-semibold text-base text-blue-900 w-full">
          Tourist Visa
        </Paragraph>
        <Flex justify="space-between" className="w-full">
          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            className="flex gap-4 items-center filterForm w-full pr-4"
          >
            {/* Processing Type */}
            <Form.Item
              className="flex-1"
              label={
                <span className="text-xs font-medium">Processing Type</span>
              }
              name="processingType"
              rules={[
                { required: true, message: "Please select processing type" },
              ]}
            >
              <Select
                placeholder="Select Processing Type"
                className="min-w-[200px]"
              >
                <Option value="normal">Normal</Option>
                <Option value="express">Express</Option>
              </Select>
            </Form.Item>

            {/* Visa Type */}
            <Form.Item
              className="flex-[2_1_0%]"
              name="visaType"
              initialValue="30 Days Single Entry Tourist Visa"
              label={<span className="text-xs font-medium">Visa Type</span>}
            >
              <div>
                <Select className="min-w-[250px]">
                  <Option value="30 Days Single Entry Tourist Visa">
                    30 Days Single Entry Tourist Visa
                  </Option>
                  <Option value="60 Days Multiple Entry Tourist Visa">
                    60 Days Multiple Entry Tourist Visa
                  </Option>
                </Select>
              </div>
            </Form.Item>

            {/* Travellers */}
            <Form.Item
              name="travellers"
              initialValue="1 adult"
              label={<span className="text-xs font-medium">Travellers</span>}
            >
              <div>
                <Select className="min-w-[160px]">
                  <Option value="1 adult">1 adult</Option>
                  <Option value="2 adults">2 adults</Option>
                  <Option value="3 adults">3 adults</Option>
                </Select>
              </div>
            </Form.Item>

            {/* Children */}
            <Form.Item
              className="flex-1"
              name="children"
              label={<span className="text-xs font-medium">Children</span>}
              initialValue="1 Child (age group 0-8)"
            >
              <div>
                <Select className="min-w-[180px]">
                  <Option value="0 Children">0 Children</Option>
                  <Option value="1 Child (age group 0-8)">
                    1 Child (age group 0-8)
                  </Option>
                  <Option value="2 Children (age group 0-8)">
                    2 Children (age group 0-8)
                  </Option>
                </Select>
              </div>
            </Form.Item>

            {/* Infants */}
            <Form.Item
              name="infants"
              initialValue="0 Infants"
              label={<span className="text-xs font-medium">Infants</span>}
            >
              <Select className="min-w-[120px]">
                <Option value="0 Infants">0 Infants</Option>
                <Option value="1 Infant">1 Infant</Option>
                <Option value="2 Infants">2 Infants</Option>
              </Select>
            </Form.Item>
          </Form>
          <div className="relative">
            {/* vertical line */}
            <div className="absolute left-0 top-0 bottom-0 w-[1px] bg-gray-200 h-[100%]"></div>
          </div>
          {/* Right Section */}
          <div className="flex w-full flex-col pl-6">
            <Text className="text-xs font-medium mb-1">Total Amount</Text>
            <Text className="text-xl font-semibold text-blue-900 mb-3">
              AED 1,932.70
            </Text>
            <Button
              type="danger"
              size="middle"
              className="mt-2 text-xs rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] 
                                bg-danger hover:bg-red-700 border-none rounded-md px-4 py-2 text-white w-fit"
            >
              Add to Cart
            </Button>
          </div>
        </Flex>
      </div>
    </div>
  );
}
